import { BankAccount } from "types/billing";
import { Address, MagicLink } from "types/landlord/address";
import { Money } from "types/landlord/reports";
import { Template } from "types/landlord/verificationTemplate";

export type SummaryItem = {
  items: BillingProperty[];
  property: {
    can_delete: boolean;
    id: number;
    magic_link: MagicLink;
    name: string;
    address: Address;
    verification_template: Template;
  };
};

type BillingProperty = {
  name: string;
  email: string;
  address: Address;
  product?: string;
  one_line_address: string;
  property_name: string;
  magic_link: MagicLink;
  property_id: number;
  unit?: string;
  items?: {
    fee: Money;
    name: string;
  }[];
};

export type statementActivity = {
  amount: Money;
  description: string;
  id: number;
  metadata: BillingProperty;
};

interface BillingPeriod {
  start: string;
  end: string;
}

export enum PayType {
  Payin = "pay_in",
  Payout = "pay_out"
}

export type statementDetails = {
  period: BillingPeriod;
  id: number;
  created_at: string;
  sending_at: string;
  paid_at: string;
  status: string;
  summary?: BillingProperty[];
  bank_account?: BankAccount;
  partner?: {
    name: string;
    address: Address;
  };
  pay_type: PayType;
};

export type NormalizedPayoutData = {
  total: number;
  items: {
    stats: Record<
      string,
      {
        name: string;
        feeInCents: number;
        count: number;
      }
    >;
    propertyTotal: number;
    items: BillingProperty[];
    property: {
      can_delete: boolean;
      id: number;
      magic_link: MagicLink;
      name: string;
      address: Address;
      verification_template: Template;
    };
  }[];
};
